module.exports = __webpack_public_path__ + "assets/img/img-login-banner.6b6c795.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img-login-banner.jpg
// module id = 852
// module chunks = 1